<template>
	<div class="mainBox" style="padding-bottom: 0.1rem;">
		<div class="topNav">
			<van-nav-bar safe-area-inset-top :placeholder="true" :fixed="true" title="巡检发现问题封闭" left-text="返回" left-arrow @click-left="goBack">
			</van-nav-bar>
		</div>
		<div class="projectItem">
			<van-row gutter="10" class="notesTop">
				<van-col span="6">
					<div class="patrolLabel isBgDarkOrange">{{problemData.majorName}}</div>
					<div class="patrolLabel isBgBlue">{{problemData.categoryName}}</div>
				</van-col>
				<van-col span="18">
					<div class="patrolTitle">{{recordData.subjectName}}</div>
				</van-col>
			</van-row>
			<div class="patrolTime">问题描述：{{recordData.sutContent}} </div>
			<div class="patrolTime">提出时间：{{problemData.poseTime}} <span class="rightText">提出人：{{problemData.poseMan}}</span></div>
		</div>
		<div class="projectItem">
			<div class="blueText">照片（整改前）</div>
			<van-row gutter="20">
				<van-col span="8" v-for="(item,index) in recordData.photo" :key="index">
						<van-image
						width="2.5rem"
						height="2.5rem"
						fit="cover"
						:src="item.photoPathUri"/>
				</van-col>
			</van-row>
		</div>
		<van-form @submit="onSubmit">
			<div class="projectItem">
				<van-field readonly clickable
				  :value="date"
				  name="date"
				  label="落实时间"
				  placeholder="请选择落实时间"
				  :rules="[{ required: true, message: '' }]"
				  @click="showDateCalendar = true"
				/>
				<van-calendar v-model="showDateCalendar" :min-date="minDate" :max-date="maxDate" color="#1989fa" @confirm="selDateCalendar" />
				<van-calendar v-model="showDateCalendar2" :min-date="minDate" :max-date="maxDate" color="#1989fa" @confirm="selDateCalendar2" />
				<van-field
					v-model="userName2"
					name="userName2"
					label="封闭人"
					placeholder="请输入封闭人"
					:rules="[{ required: true, message: '' }]"
				/>
				<van-field
					class="uploaderField blueText"
					name="photoList" label="照片（整改后）">
					<template #input>
						<van-uploader v-model="photoList" :after-read="uploadFile" :before-delete="beforeDelete" accept="image/*" multiple/>
					</template>
				</van-field>
			</div>
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">保存</van-button>
			</div>
		</van-form>
	</div>
</template>
<script>
	import { info, updateClose } from '../../api/qualityPatrol'
	import { getSutConclusion, upload } from '../../api/commonApi'
	import { getNowDate } from "../../utils/date"
	import { Notify } from 'vant';
	import common from '../../utils/common';
	import ImageCompressor from '@/utils/ImageCompressor'

	export default {
		name: 'qualityPatrolClose',
		data() {
			return {
				date: "",
				showDateCalendar: false,
				userName: "",
				date2: "",
				showDateCalendar2: false,
				userName2: "",
				conclusion: "合格",
				conclusionId: "1",
				// 整改结论
				conclusionList: [
				],
				photoList:[],
				afterPhotoList:[],
				// 项目名称
				projectName: '',
				recordData: {},
				// problem 对象Object
				problemData: {},
				id: '',
				param: {},
				minDate: new Date(new Date().getFullYear()-2, 0, 1,0,0,0),
				maxDate: new Date(new Date().getFullYear()+2, 11, 31,23,59,59),
				project: {},
				user: {},
				businessType:"10", // 业务类型: 01:报验记录照片 10:问题照片 11:问题及意见文件 20:收文、发文、周报、月报等文件信息 93:协调记录照片 94:质量进度照片 95:周月报照片临时文件 96:完工资料 97:合同扫描件 98:加班审核 99:请假审核"
				fileKey:"0", // 业务类型=(01、10、11、96、97、98、99)时，默认值0，业务类型=20时，需要传入文件类型下拉选择列表对应的VALUE")

			}
		},
		mounted() {
			this.project = common.getProject();
			if(this.project == null || this.project == undefined){
				Notify({ type: 'danger', message: '获取项目信息失败' });
			}
			this.projectName = this.project.projectName
			this.user = common.getUser();
			this.userName = this.user.username
			this.userName2 = this.user.username
			this.date = getNowDate()
			this.date2 = getNowDate()
			this.id = this.$route.query.id;
			this.getProbleminfo(this.id)
		},
		methods: {
			getProbleminfo(id){
				info(id).then(response => {
					this.recordData = response.data.body
					this.problemData = response.data.body.problem
					this.param = this.problemData
				})
			},
			goBack() {
				this.$router.push({
					name: 'qualityPatrolList'
				});
			},
			selDateCalendar(date){
				this.date = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
				this.showDateCalendar = false;
			},
			selDateCalendar2(date){
				this.date2 = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
				this.showDateCalendar2 = false;
			},
			selConclusionPicker(data){
				this.conclusion = data.displayName;
				this.conclusionId = data.displayValue;
				this.showConclusionPicker = false;
			},
			async uploadFile(file) {
			    // 此时可以自行将文件上传至服务器
				const files = file.file;
      			let newFile = await ImageCompressor(files); //图片压缩
      			const formData = new FormData();
      			formData.append('file', newFile);
				const url = this.project.workNo + "/" + this.businessType + "/" + this.fileKey;
				upload(url, formData).then(response => {
					if (response.data.resultCode === 200){
						const dataBody = response.data.body
						this.afterPhotoList.push(
							{
								photoName: dataBody.fileName,
								photoPath: dataBody.fileSavePath,
								fileUri: dataBody.fileUri
							}
						)
					}
				})
			},
			beforeDelete(file, detail) {
				this.photoList.splice(detail.index, 1)
				// 删除照片
				this.afterPhotoList.splice(detail.index, 1)
			},
			onSubmit(data) {
				this.param.t = new Date().getTime(),
				this.param.implMan = this.userName,
				this.param.implTime = this.date,
				this.param.sutConclusion = this.conclusionId,
				this.param.closeTime = this.date2,
				this.param.closeMan = this.userName2,
				// 封闭时照片list
				this.param.afterPhotoList = this.afterPhotoList,
				updateClose(this.param).then(response => {
					if (response.data.resultCode === 200){
						Notify({ type: 'success', message: '操作成功' });
						this.goBack()
					} else {
						Notify({ type: 'danger', message: response.data.resultMessage });
					}
				})
			},
		}
	}
</script>
<style lang="scss" src="@/assets/sass/common.scss"></style>
